export default __webpack_public_path__ + "static/media/MISTRZ_BOHATERSTWA.16aed956.png";